'use client'
import React from 'react'

export default function Banner({ title }: { title: string }) {
  return (
    <div className="relative left-1/2 right-1/2 mx-[-50vw] w-screen">
      <section className="bg-gradient-to-r from-[#009fe3] to-[#3bb0e7] text-white py-12">
        <div className="max-w-screen-xl mx-auto px-8 text-left">
          <h1 className="text-3xl md:text-4xl font-bold !mb-0">
            {title}
          </h1>
        </div>
      </section>
    </div>
  )
}

